/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface CallLogEntry { 
    id?: number;
    sessionId?: number;
    organization?: string;
    login?: string;
    serviceNumber?: string;
    serviceNumberName?: string;
    cid?: number;
    cidName?: string;
    aNumber?: string;
    genericNumber?: string;
    clir?: boolean;
    start?: Date;
    end?: Date;
    history?: string;
    cause?: number;
    firstName?: string;
    lastName?: string;
    company?: string;
    triedCallBack?: Date;
    comment?: string;
    handledBy?: string;
}
